'use client'

import { ContactsOrganisationsSelectModal } from '@repo/contacts-organisations/ContactsOrganisationsSelectModal'
import {
  CustomDataContactsOrganisationsEditState,
  CustomDataContactsOrganisationsEditStateRow
} from '@repo/custom-data-pages/CustomDataContactsOrganisationsEditState'
import { TextLinkButton } from '@repo/ui/TextLinkButton'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'
import { useState, useEffect } from 'react'
import MUIStack from '@mui/material/Stack'
import PropTypes from 'prop-types'

export const CustomDataFieldContact = ({ value, onChange, field, validationErrors }) => {
  const [showDialog, setShowDialog] = useState(false)
  const [contact, setContact] = useState(null)

  const { fetchContactById, contactsById } = useLookupsStore()
  const { allowedActions } = useMenuItemsStore()
  const allowEditContacts = allowedActions?.editContacts?.allowed || false

  const handleSelection = (selectedItem) => {
    if (selectedItem) {
      const { contactId } = selectedItem
      if (onChange) onChange(Number(contactId))
    } else {
      if (onChange) onChange(null)
      setContact(null)
    }
    setShowDialog(false)
  }

  const clearContact = () => {
    if (onChange) onChange(null)
    setContact(null)
  }

  useEffect(() => {
    if (!value) {
      setContact(null)
      return
    }

    const fetchContact = async () => {
      const contact = await fetchContactById({ id: value })
      setContact(contact)
    }

    if (contactsById?.[value]) {
      setContact(contactsById[value])
    } else {
      fetchContact()
    }
  }, [value, fetchContactById, contactsById])

  const hasErrors = validationErrors?.length > 0 || false

  return (
    <>
      <MUIStack
        data-testid="CustomDataFieldContact"
        direction="column"
        sx={{
          border: `1px solid ${hasErrors ? '#C33241' : 'rgb(0, 0, 0, 0.23)'}`,
          borderRadius: '4px',
          width: '100%'
        }}
      >
        <CustomDataContactsOrganisationsEditStateRow
          title="Contact"
          label={
            <MUIStack direction="row" justifyContent="flex-end" alignItems="center" gap={0} sx={{ width: '100%' }}>
              <TextLinkButton
                title={allowEditContacts ? 'Add / Edit / Select' : 'Select'}
                onClick={() => setShowDialog(true)}
                sx={{ mt: 0, minWidth: 'unset', width: 'auto', p: '0 10px' }}
              />
              <span style={{ color: 'rgb(0, 0, 0, 0.36)' }}>|</span>
              <TextLinkButton
                title={'Clear'}
                onClick={clearContact}
                sx={{ mt: 0, minWidth: 'unset', width: 'auto', p: '0 10px' }}
              />
            </MUIStack>
          }
          isFirst
        />

        <CustomDataContactsOrganisationsEditState item={contact} />
      </MUIStack>
      <ContactsOrganisationsSelectModal
        open={showDialog}
        onClose={handleSelection}
        initialSelectedItem={contact}
        mode="contacts"
        preSelectExpertTypeId={field?.expertTypeId || null}
      />
    </>
  )
}

CustomDataFieldContact.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  field: PropTypes.object,
  validationErrors: PropTypes.array,
  fieldTypeIsString: PropTypes.bool,
  fieldTypeIsNumber: PropTypes.bool,
  fieldTypeIsAnId: PropTypes.bool
}
